import GoogleIcon from "components/icons/GoogleIcon";
import getBaseUrl from "lib/utils/getBaseUrl";
import type { ReactNode } from "react";

interface GoogleOAuthButtonProps {
  children: ReactNode;
}

export default function GoogleOAuthButton({ children }: GoogleOAuthButtonProps) {
  const oauthCallbackHref = encodeURIComponent(`${getBaseUrl()}/oauth-callback`);
  const connectWithGoogleHref = `https://oauth.fundamentei.dev/connect/google?redirect=${oauthCallbackHref}`;

  return (
    <a
      href={connectWithGoogleHref}
      className="flex w-full items-center justify-center gap-2 rounded-md bg-gray-100 p-2.5 text-center text-sm font-medium text-gray-600 hover:bg-black hover:text-white"
    >
      <GoogleIcon white={false} width={18} height={18} />
      <span>{children}</span>
    </a>
  );
}
